import React from 'react'
export const TickIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="80%" viewBox="0 0 10 4" fill="currentColor">
      <path d="M7.83261 0.175754C8.0558 0.410092 8.0558 0.790658 7.83261 1.025L3.26169 5.82425C3.0385 6.05858 2.67604 6.05858 2.45285 5.82425L0.167392 3.42462C-0.0557973 3.19028 -0.0557973 2.80972 0.167392 2.57538C0.390581 2.34104 0.753041 2.34104 0.97623 2.57538L2.85816 4.54945L7.02555 0.175754C7.24874 -0.0585846 7.6112 -0.0585846 7.83439 0.175754H7.83261Z"
        fill="currentColor" />
    </svg>
  )
}
